var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgParkmap = function SvgParkmap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.45 2.83a3.5 3.5 0 0 0-3.29-.32l-2.85 1.18a1.47 1.47 0 0 1-1.13 0L9.57 1.45a3.5 3.5 0 0 0-2.64 0l-4.77 2A3.49 3.49 0 0 0 0 6.67v11.59a3.49 3.49 0 0 0 4.84 3.23l2.85-1.18a1.47 1.47 0 0 1 1.13 0l5.61 2.24c.413.166.855.251 1.3.25.46-.001.914-.09 1.34-.26l4.77-2A3.49 3.49 0 0 0 24 17.33V5.74a3.5 3.5 0 0 0-1.55-2.91ZM4.07 19.65A1.5 1.5 0 0 1 2 18.26V6.67a1.5 1.5 0 0 1 .93-1.39l4.38-1.81v14.88c-.13 0-.26.06-.38.11l-2.86 1.19Zm5.5-1.2a2.726 2.726 0 0 0-.38-.11V3.45l5.24 2.1c.114.043.23.076.35.1v14.88l-5.21-2.08ZM22 17.33a1.48 1.48 0 0 1-.93 1.38l-4.35 1.81V5.64l.35-.1 2.86-1.19A1.5 1.5 0 0 1 22 5.74v11.59Z"
  })));
};

export default SvgParkmap;